import { render, staticRenderFns } from "./goGrouping.vue?vue&type=template&id=fea1f490&scoped=true"
import script from "./goGrouping.vue?vue&type=script&lang=js"
export * from "./goGrouping.vue?vue&type=script&lang=js"
import style0 from "./goGrouping.vue?vue&type=style&index=0&id=fea1f490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea1f490",
  null
  
)

export default component.exports